import styled from 'styled-components';
import { colors } from '../colors';

const OutgoingChat = styled.div`
	width: auto;
	max-width: 375px;
	padding: 14px;
	border-radius: 14px 0 14px 14px;
	background: ${colors.OutgoingChatbg};
	color: ${colors.BlueBase};
	font-size: 14px;
	line-height: 21px;
	margin-top: 6px;
	position: relative;
	${({ chatImage }) =>
		chatImage &&
		`padding: 6px;
        overflow: hidden;
        display: flex;
        img{
			max-width: 100%;
			width: auto;
            border-radius: 14px 0 14px 14px;
		} 
		video{
			border-radius: 14px 0 14px 14px;
		}
	`}
	div {
		display: flex;
	}
`;

export default OutgoingChat;
